export const quantityTypes: { id: string; name: string; }[] = [
  {
    id: 'voucher',
    name: 'voucher',
  },
  {
    id: 'session',
    name: 'session',
  },
  {
    id: 'total',
    name: 'total',
  },
];